"use strict";
var twentyninetimes = twentyninetimes || {};

twentyninetimes.navigation =
  twentyninetimes.navigation ||
  (function () {
    const site_overlay = document.getElementById("js-site-header-overlay");
    const site_nav = document.getElementById("js-site-nav");
    const site_nav_inner = site_nav.querySelector('.site-nav__inner');

    function init() {
      if (site_overlay && site_nav) {
        siteNav(site_nav, site_overlay);
        sub_menu_toggle(site_nav);
        setupSubMenuTriggers();
      }
    }

    function setupSubMenuTriggers() {
      const subMenuTriggersDepth1 = document.querySelectorAll(
        ".js-sub-menu-trigger-depth-1"
      );
      const subMenuTriggersDepth2 = document.querySelectorAll(
        ".js-sub-menu-trigger-depth-2"
      );

      if (subMenuTriggersDepth1) {
        for (var i = 0; i < subMenuTriggersDepth1.length; i++) {
          var current = subMenuTriggersDepth1[i];
          current.addEventListener("click", function (e) {
            var clicked = e.currentTarget;
            var parentMenuItem = clicked.parentNode;
            parentMenuItem.classList.toggle("menu-item--open");
            var subMenuWrap = parentMenuItem.querySelector(".js-sub-menu-wrap");
            subMenuWrap.classList.toggle("sub-menu-wrap--open");

            site_overlay.scrollTop = 0;
          });
        }
      }
      if (subMenuTriggersDepth2) {
        for (var i = 0; i < subMenuTriggersDepth2.length; i++) {
          var current = subMenuTriggersDepth2[i];
          current.addEventListener("click", function (e) {
            var clicked = e.currentTarget;
            var parentMenuItem = clicked.parentNode;
            parentMenuItem.classList.add("open");

            var subMenuCloseLink =
              parentMenuItem.querySelector(".js-sub-menu-close");
            if (subMenuCloseLink) {
              subMenuCloseLink.addEventListener("click", function () {
                parentMenuItem.classList.remove("open");
              });
            }
            // var parentMenuItem = clicked.parentNode;
            // parentMenuItem.classList.toggle("menu-item--open");
            // var subMenuWrap = parentMenuItem.querySelector(".js-sub-menu-wrap");
            // subMenuWrap.classList.toggle("sub-menu-wrap--open");
            site_overlay.scrollTop = 0;
          });
        }
      }
    }

    function siteNav(site_nav, site_overlay) {
      var site_body = document.body,
        nav_toggle = document.getElementById("js-mobile-nav-toggle");

      nav_toggle.addEventListener("click", function (event) {
        event.stopPropagation();

        var btn = event.target,
          site_nav_item = site_nav.querySelectorAll(
            ".site-nav__inner > .menu > .menu-item"
          ),
          i = 0;

        if (!site_body.classList.contains("nav-active")) {
          site_body.classList.add("nav-active");
          nav_toggle.setAttribute("aria-expanded", true);

          // Disable scrolling
          site_body.classList.add("no-scroll");
          //bodyScrollLock.disableBodyScroll(site_nav);

          function site_nav_item_timeout(i) {
            setTimeout(function () {
              site_nav_item[i].classList.add("visible");
            }, i * 50);
          }

          function site_nav_timeout(i) {
            site_nav_item_timeout(i);
          }

          for (i = 0; i < site_nav_item.length; i++) {
            site_nav_timeout(i);

            var current = site_nav_item[i];

            if (
              !current.classList.contains("open") &&
              current.classList.contains("current-menu-ancestor")
            ) {
              var current_open = current,
                sub_menu = current.querySelector(".sub-menu");

              setTimeout(function () {
                // sub_menu.style.height = "100%";
                // var height = sub_menu.scrollHeight + "px";
                // sub_menu.style.height = "";

                // sub_menu.style.height = height;
                current_open.classList.add("open");
              }, 900);
            }
          }

          var floatingBtns = document.getElementById('phonefloatercontent');
          if ( floatingBtns ) floatingBtns.classList.add('hide');

          i = 0;
        } else {
          for (i = 0; i < site_nav_item.length; i++) {
            site_nav_item[i].classList.remove("visible");
          }

          i = 0;

          site_body.classList.remove("nav-active");
          nav_toggle.setAttribute("aria-expanded", false);

          // Re-activate scrolling
          site_body.classList.remove("no-scroll");
          //bodyScrollLock.enableBodyScroll(site_nav);

          var floatingBtns = document.getElementById('phonefloatercontent');
          if ( floatingBtns ) floatingBtns.classList.remove('hide');
        }
      });
    }

    function sub_menu_toggle(site_nav) {
      var site_nav_item = site_nav.getElementsByClassName(
        "menu-item-has-children"
      );

      if (site_nav_item) {
        for (var i = 0; i < site_nav_item.length; i++) {
          var sub_menu_toggle = site_nav_item[i].querySelector(
            ".js-sub-menu-toggle"
          );

          sub_menu_toggle.addEventListener("click", function () {
            var nav_item = this.parentElement,
              sub_menu = nav_item.querySelector(".sub-menu");

            if (!nav_item.classList.contains("open")) {
              // sub_menu.style.height = "100%";
              // var height = sub_menu.scrollHeight + "px";
              sub_menu.style.height = "";

              // sub_menu.style.height = height;
              nav_item.classList.add("open");
            } else {
              sub_menu.style.height = "0px";
              nav_item.classList.remove("open");
            }
          });
        }
      }
    }

    return {
      init: init,
    };
  })();
